import React, { useState, useEffect, useMemo, useCallback, useRef } from "react";
import classes from "./Deduction.module.css";
import HeaderNav from "../../../Components/Dahboard Header/HeaderNav/HeaderNav";
import { useLocation, useNavigate } from "react-router-dom";
import searchicon from "../../../Assets/searchicon.png";
import Footer from "../../../Components/Footer/Footer";
import { Plus, Trash2, Upload } from "lucide-react";
import "react-loading-skeleton/dist/skeleton.css";
import api, { withCompanyId } from "../../../Components/API/Api";
import Skeleton from "react-loading-skeleton";
import Swal from "sweetalert2";
import Select from "react-select";
import filter from "../../../Assets/filter.png";
import { useUser } from "../../../UserContext";
import { Eye, Edit, Trash } from 'lucide-react';


const MonthlyDeduction = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isNewModalOpen, setIsNewModalOpen] = useState(false);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [NewUser, setNewUser] = useState([]);
  const [deductionTypes, setDeductionTypes] = useState([]);
  const [storeOptions, setStoreOptions] = useState([]);
  const [selectedLocation, setSelectedLocation] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [submitting, setSubmitting] = useState(false);
  const [deleting, setDeleting] = useState(false);
  const [currency, setCurrency] = useState("");
  const [currencySearch, setCurrencySearch] = useState("");
  const [showCurrency, setShowCurrency] = useState(false);
  const [selectedCurrencyText, setSelectedCurrencyText] = useState("");
  const [reference, setReference] = useState("");
  const [currencies, setCurrencies] = useState([]);
  const [bearer, setBearer] = useState('');
  const { user } = useUser();
  const [baseCurrencyCode, setBaseCurrencyCode] = useState('');
  const [isCompanyLoading, setIsCompanyLoading] = useState(false);
  const [isCurrenciesLoading, setIsCurrenciesLoading] = useState(false);
  const [loadingDots, setLoadingDots] = useState(0);
  const [isUploadModalOpen, setIsUploadModalOpen] = useState(false);
  const [employeeOptions, setEmployeeOptions] = useState([]);
  const [isEmployeeLoading, setIsEmployeeLoading] = useState(false);
  const [uploadForm, setUploadForm] = useState({ month: "", deductionType: null });
  const [employeeRows, setEmployeeRows] = useState([{ employee: null, amount: "" }]);
  const [excelFile, setExcelFile] = useState(null);
  const [uploadedFromExcel, setUploadedFromExcel] = useState(false);
  const [uploadedRows, setUploadedRows] = useState([]);
  const [uploadSubmitting, setUploadSubmitting] = useState(false);
  const [templateDownloading, setTemplateDownloading] = useState(false);
  const excelFileInputRef = useRef(null);

  const deductionTypeOptions = useMemo(() => {
    if (!Array.isArray(deductionTypes)) {
      return [];
    }
    return deductionTypes.map((type) => {
      const id =
        type?.id ??
        type?.ID ??
        type?.deduction_id ??
        type?.Deduction_id ??
        type?.deductionId;
      const identifier = id || "";
      const label =
        type?.description ||
        type?.name ||
        type?.title ||
        type?.Deduction ||
        `Deduction ${identifier}`;
      return {
        value: identifier,
        label,
        raw: type,
      };
    });
  }, [deductionTypes]);

  const employeeSelectOptions = useMemo(() => {
    if (!Array.isArray(employeeOptions)) {
      return [];
    }
    return employeeOptions.map((emp) => {
      const id =
        emp?.id ??
        emp?.employee_id ??
        emp?.Employee_id ??
        emp?.staff_id ??
        emp?.staffId ??
        emp?.user_id;
      const names = [
        emp?.first_name,
        emp?.middle_name,
        emp?.last_name,
      ].filter(Boolean);
      const fallbackName =
        emp?.full_name || emp?.name || emp?.employee_name || `Employee ${id || ""}`;
      const displayName = names.length ? names.join(" ") : fallbackName;
      const code =
        emp?.employee_id ??
        emp?.staff_id ??
        emp?.unique_id ??
        emp?.employee_code ??
        emp?.employeeId ??
        emp?.code;
      const label = code ? `${displayName} (${code})` : displayName;
      return {
        value: id ?? code,
        label,
        raw: emp,
      };
    });
  }, [employeeOptions]);

  const pageMap = {
    "/dashboard": "Dashboard",
    "/transactions": "Transactions",
    "/accounts": "Accounting",
    "/reports": "Reports",
    "/banking": "Banking",
    "/settings": "Settings",
  };

  const [formData, setFormData] = useState({
    description: "",
    payable_account: "",
    expense_account: "",
  });


  const [editFormData, setEditFormData] = useState({
    date: "",
    currency: "",
    exchange_rate: "",
  });

  const handleChange = (eOrName, value) => {
    if (typeof eOrName === "string") {
      setFormData((prev) => ({ ...prev, [eOrName]: value }));
    } else {
      const { name, value } = eOrName.target;
      setFormData((prev) => ({ ...prev, [name]: value }));
    }
  };

  const handleEditChange = (eOrName, value) => {
    if (typeof eOrName === "string") {
      setEditFormData((prev) => ({ ...prev, [eOrName]: value }));
    } else {
      const { name, value } = eOrName.target;
      setEditFormData((prev) => ({ ...prev, [name]: value }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);

    try {
      const token = localStorage.getItem("authToken");

      const payload = {
        description: formData.description,
        payable_account: formData.payable_account,
        expense_account: formData.expense_account,
      };

      console.log("Payload being sent:", payload); // Debug log to inspect payload

      const response = await api.post('/v1/create-deduction-type', withCompanyId(payload));

      // Reset form
      setFormData({
        description: "",
        payable_account: "",
        expense_account: "",
      });
      setIsModalOpen(false);
      // Refresh the list
      fetchDeductionTypes();

      Swal.fire({
        icon: "success",
        title: "Deduction Added",
        text: response.data.message || "Deduction added successfully!",
        timer: 2000,
        showConfirmButton: false,
      });
    } catch (error) {
      const errorMessage =
        typeof error.response?.data?.message === "object"
          ? Object.values(error.response.data.message).flat().join("\n")
          : error.response?.data?.message || "Something went wrong.";

      Swal.fire({
        icon: "error",
        title: "Failed to Add Deduction",
        text: errorMessage,
      });
    } finally {
      setSubmitting(false);
    }
  };


  const fetchInitialData = async () => {
    const token = localStorage.getItem("authToken");
    try {
      setIsCurrenciesLoading(true);
      const [refRes, currencyRes] = await Promise.all([
        api.get('/v1/generate-sales-invoice-code'),
        api.get('/v1/fetch-all-currencies'),
      ]);
      if (refRes?.data?.data) setReference(refRes.data.data.toString());
      if (currencyRes?.data?.data) setCurrencies(currencyRes.data.data);
    } catch (error) {
      console.error("Error fetching initial data:", error);
    } finally {
      setIsCurrenciesLoading(false);
    }
  };

  const fetchCompanyInfo = async () => {
    const token = localStorage.getItem("authToken");
    try {
      setIsCompanyLoading(true);
          const res = await api.get(`/v1/companies/get-info`);
      const item = Array.isArray(res?.data?.data) ? res.data.data[0] : null;
      const code = (item?.currency_base || '').toString().trim().toUpperCase();
      if (code) setBaseCurrencyCode(code);
    } catch (err) {
      console.error("Failed to fetch company info", err);
    } finally {
      setIsCompanyLoading(false);
    }
  };

  useEffect(() => {
    const authToken = localStorage.getItem("authToken");
    setBearer(authToken);
    if (authToken) {
     
    }  }, []);
  // Set user's base currency as default once currencies are loaded (fallback to NGN)
  useEffect(() => {
    if (!currency && Array.isArray(currencies) && currencies.length > 0) {
      const userBaseCode = (baseCurrencyCode || user?.currency_base || user?.base_currency || user?.baseCurrency || user?.currency_code || user?.settings?.base_currency || '').toString().trim().toUpperCase();

      let preferred = null;
      if (userBaseCode) {
        preferred = currencies.find(cur => String(cur.code).toUpperCase() === userBaseCode);
      }

      const ngn = currencies.find(cur =>
        (cur.code && String(cur.code).toUpperCase() === 'NGN') ||
        (cur.symbol && (String(cur.symbol).includes('₦') || String(cur.symbol).toUpperCase() === 'NGN')) ||
        (cur.country && String(cur.country).toLowerCase().includes('nigeria'))
      );

      const chosen = preferred || ngn || null;
      if (chosen) {
        setCurrency(chosen.id);
        setSelectedCurrencyText(`${chosen.symbol} ${chosen.code} - ${chosen.country}`);
        setFormData(prev => ({ ...prev, currency: chosen.id }));
      }
    }
  }, [currencies, currency, user, baseCurrencyCode]);

  const [selectedCurrency, setSelectedCurrency] = useState(null);
  const [expenseAccounts, setExpenseAccounts] = useState([]);
  const [isExpenseAccountsLoading, setIsExpenseAccountsLoading] = useState(false);
  const [payableAccounts, setPayableAccounts] = useState([]);
  const [isPayableAccountsLoading, setIsPayableAccountsLoading] = useState(false);
  const currencyOptions = currencies.map(cur => ({
    value: cur.id,
    label: `${cur.symbol} ${cur.code} - ${cur.country}`,
    currency: cur
  }));

  const handleEditSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);

    try {
      const token = localStorage.getItem("authToken");

      const payload = {
        date: editFormData.date,
        id: editFormData.currency, // API expects 'id' field
        exchange_rate: editFormData.exchange_rate,
      };

      const response = await api.post('/v1/exchange-rate/update', withCompanyId(payload), { params: { id: selectedLocation.id } });

      setIsNewModalOpen(false);
      setSelectedLocation(null);

      // fetchExchangeRates(); 
      // Refresh the list

      Swal.fire({
        icon: "success",
        title: "Exchange Rate Updated",
        text: response.data.message || "Exchange rate updated successfully!",
        timer: 2000,
        showConfirmButton: false,
      });
    } catch (error) {
      const errorMessage =
        typeof error.response?.data?.message === "object"
          ? Object.values(error.response.data.message).flat().join("\n")
          : error.response?.data?.message || "Failed to update exchange rate.";

      Swal.fire({
        icon: "error",
        title: "Failed to Update Exchange Rate",
        text: errorMessage,
      });
    } finally {
      setSubmitting(false);
    }
  };

  const handleDelete = async () => {
    setDeleting(true);

    try {
      const token = localStorage.getItem("authToken");

      const response = await api.get('/v1/salary_deduction/delete', { params: { id: selectedLocation.id } });

      setIsDeleteModalOpen(false);
      setSelectedLocation(null);
      fetchDeductionTypes(); // Refresh the list

      Swal.fire({
        icon: "success",
        title: "Deduction Deleted",
        text: response.data.message || "Deduction deleted successfully!",
        timer: 2000,
        showConfirmButton: false,
      });
    } catch (error) {
      const errorMessage =
        error.response?.data?.message || "Failed to delete deduction.";

      Swal.fire({
        icon: "error",
        title: "Failed to Delete Deduction",
        text: errorMessage,
      });
    } finally {
      setDeleting(false);
    }
  };

  const openEditModal = (exchangeRate) => {
    setSelectedLocation(exchangeRate);
    setEditFormData({
      date: exchangeRate.date || exchangeRate.Date,
      currency: exchangeRate.currency?.id || exchangeRate.Currency?.id || exchangeRate.currency_id || exchangeRate.Currency_id,
      exchange_rate: exchangeRate.exchange_rate || exchangeRate.Exchange_rate,
    });
    setIsNewModalOpen(true);
  };

  const openDeleteModal = (exchangeRate) => {
    setSelectedLocation(exchangeRate);
    setIsDeleteModalOpen(true);
  };

  useEffect(() => {
    const authToken = localStorage.getItem("authToken");

    if (!authToken) {
      setError("Authorization token not found.");
      navigate("/signin");
      return;
    }

    fetchStore();
    fetchDeductionTypes();
    fetchAvailableDeductionTypes();
    fetchExpenseAccounts();
    fetchPayableAccounts();
    fetchInitialData();
    fetchCompanyInfo();

  }, [navigate]);

  // Animate pulsating ellipses while loading
  useEffect(() => {
    const anyLoading = isCompanyLoading || isCurrenciesLoading;
    if (!anyLoading) {
      setLoadingDots(0);
      return;
    }
    const id = setInterval(() => {
      setLoadingDots(prev => (prev + 1) % 4);
    }, 350);
    return () => clearInterval(id);
  }, [isCompanyLoading, isCurrenciesLoading]);

  const fetchEmployees = useCallback(async () => {
    const token = localStorage.getItem("authToken");
    if (!token) {
      return;
    }
    try {
      setIsEmployeeLoading(true);
      const response = await api.get('/v1/employee');
      const employees = Array.isArray(response?.data?.data) ? response.data.data : [];
      setEmployeeOptions(employees);
    } catch (error) {
      console.error("Failed to fetch employees:", error?.response?.data || error.message);
      setEmployeeOptions([]);
    } finally {
      setIsEmployeeLoading(false);
    }
  }, []);

  useEffect(() => {
    if (!isUploadModalOpen) {
      return;
    }
    if (employeeOptions.length > 0) {
      return;
    }
    fetchEmployees();
  }, [isUploadModalOpen, employeeOptions.length, fetchEmployees]);

  const fetchStore = async () => {
    const token = localStorage.getItem("authToken");
    try {
      const response = await api.get('/v1/store');

      if (response.data.status) {
        setStoreOptions(
          response.data.data.map((s) => ({ value: s.id, label: s.store_name }))
        );
      }
    } catch (error) {
      console.error("Failed to fetch stores:", error);
      if (error.response?.status === 401) {
        localStorage.removeItem("authToken");
        navigate("/login");
      }
    }
  };

  const fetchExpenseAccounts = async () => {
    const token = localStorage.getItem("authToken");
    if (!token) {
      return;
    }

    try {
      setIsExpenseAccountsLoading(true);
      const response = await api.get('/v1/get-expense-accounts');

      const accounts = Array.isArray(response?.data?.data)
        ? response.data.data
        : [];

      setExpenseAccounts(accounts);
    } catch (error) {
      console.error(
        "Failed to fetch expense accounts:",
        error?.response?.data || error.message
      );
    } finally {
      setIsExpenseAccountsLoading(false);
    }
  };

  const fetchPayableAccounts = async () => {
    const token = localStorage.getItem("authToken");
    if (!token) {
      return;
    }

    try {
      setIsPayableAccountsLoading(true);
      const response = await api.get('/v1/get-payable-accounts');

      const accounts = Array.isArray(response?.data?.data)
        ? response.data.data
        : [];

      setPayableAccounts(accounts);
    } catch (error) {
      console.error(
        "Failed to fetch payable accounts:",
        error?.response?.data || error.message
      );
    } finally {
      setIsPayableAccountsLoading(false);
    }
  };

  const fetchDeductionTypes = async () => {
    const token = localStorage.getItem("authToken");
    if (!token) {
      // No token - clear state and redirect to signin
      setError("Authorization token not found.");
      localStorage.removeItem("authToken");
      navigate("/signin");
      setNewUser([]); // ensure UI clears
      setLoading(false);
      return;
    }

    try {
      // IMPORTANT: pass config as second argument so headers are sent
      const res = await api.get('/v1/salary_deduction/get_employee_deduction');

      setNewUser(res.data?.data || []);
    } catch (err) {
      console.error("Error fetching deduction types:", err?.response?.data || err.message);
      if (err?.response?.status === 401) {
        localStorage.removeItem("authToken");
        setError("Session expired. Please login again.");
        navigate("/signin");
      } else {
        setError("Failed to fetch deduction types. Please try again.");
      }
      setNewUser([]); // clear state to avoid undefined in UI
    } finally {
      setLoading(false);
    }
  };

  const fetchAvailableDeductionTypes = async () => {
    const token = localStorage.getItem("authToken");
    try {
      const res = await api.get('/v1/get-deduction-type');

      setDeductionTypes(res.data?.data || []);
    } catch (err) {
      console.error("Error fetching available deduction types:", err?.response?.data || err.message);
    }
  };

  const getCurrencyName = (currencyId) => {
    const currency = currencies.find(cur => cur.id == currencyId);
    return currency ? `${currency.symbol} ${currency.code} - ${currency.country}` : currencyId;
  };

  const getStoreName = (storeId) => {
    const store = storeOptions.find(option => option.value === storeId);
    return store ? store.label : storeId;
  };

  const handleOpenUploadModal = () => {
    setIsUploadModalOpen(true);
  };

  const resetUploadState = () => {
    setUploadForm({ month: "", deductionType: null });
    setEmployeeRows([{ employee: null, amount: "" }]);
    setExcelFile(null);
    if (excelFileInputRef.current) {
      excelFileInputRef.current.value = "";
    }
  };

  const handleCloseUploadModal = () => {
    setIsUploadModalOpen(false);
    resetUploadState();
    setUploadSubmitting(false);
  };

  const handleAddEmployeeRow = () => {
    setEmployeeRows((prev) => [...prev, { employee: null, amount: "" }]);
  };

  const handleRemoveEmployeeRow = (index) => {
    setEmployeeRows((prev) => {
      if (prev.length <= 1) {
        return prev;
      }
      return prev.filter((_, idx) => idx !== index);
    });
  };

  const handleEmployeeRowChange = (index, field, value) => {
    setEmployeeRows((prev) =>
      prev.map((row, idx) =>
        idx === index
          ? {
            ...row,
            [field]: value,
          }
          : row
      )
    );
  };

  const handleDownloadTemplate = async () => {
    const companyId =
      user?.company_id ??
      user?.companyId ??
      user?.company?.id ??
      user?.company?.company_id ??
      user?.Company_id ??
      user?.CompanyId ??
      user?.companyID ??
      null;

    if (!companyId) {
      Swal.fire({
        icon: "warning",
        title: "Company Required",
        text: "Unable to determine your company. Please re-login or contact support.",
      });
      return;
    }

    const token = localStorage.getItem("authToken");
    try {
      setTemplateDownloading(true);
      const response = await api.get('/v1/download-employee-deduction-template', { params: { company_id: companyId }, responseType: 'blob' });
      const blob = new Blob([response.data]);
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "monthly_deduction_template.xlsx");
      document.body.appendChild(link);
      link.click();
      if (document.body.contains(link)) {
        document.body.removeChild(link);
      }
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Failed to download deduction template:", error?.response?.data || error.message);
      Swal.fire({
        icon: "error",
        title: "Download Failed",
        text: error?.response?.data?.message || "Unable to download deduction template. Please try again later.",
      });
    } finally {
      setTemplateDownloading(false);
    }
  };

  const handleUploadExcel = async (event) => {
    const file = event.target.files?.[0];
    if (!file) {
      return;
    }

    const isValid =
      file.name.toLowerCase().endsWith(".xls") || file.name.toLowerCase().endsWith(".xlsx");

    if (!isValid) {
      Swal.fire({
        icon: "warning",
        title: "Invalid File",
        text: "Please select an Excel file (.xls or .xlsx).",
      });
      event.target.value = "";
      return;
    }

    // Ensure `date` and `deduction_type` are provided
    if (!uploadForm.month || !uploadForm.deductionType) {
      Swal.fire({
        icon: "warning",
        title: "Missing Information",
        text: "Please select a month and deduction type before uploading the file.",
      });
      return;
    }

    const token = localStorage.getItem("authToken");
    const formData = new FormData();
    formData.append("file", file);
    formData.append("date", `${uploadForm.month}-01`); // Add the date field
    formData.append("deduction_type", uploadForm.deductionType.value); // Add the deduction type field

    try {
      setUploadSubmitting(true);

      const response = await api.post('/v1/salary_deduction/upload_employee_deduction', withCompanyId(formData), { headers: { 'Content-Type': 'multipart/form-data' } });

      const { data } = response.data;
      const { uuid, upload_record } = data;

      // Populate uploadedRows with data from the uploaded file and keep manual rows available
      const populatedRows = upload_record.map((record) => {
        const employeeName = `${record.employee.first_name} ${record.employee.last_name}`;
        return {
          employee: { label: employeeName, value: record.employee.id },
          amount: record.amount,
        };
      });

      setUploadedRows(populatedRows); // Keep uploaded entries separate for display/submission
      setEmployeeRows([{ employee: null, amount: "" }]); // reset manual rows so user can still add new ones
      setUploadForm((prev) => ({ ...prev, uuid })); // Store the UUID for submission
      setExcelFile(file);
      setUploadedFromExcel(true);

      Swal.fire({
        icon: "success",
        title: "File Uploaded",
        text: "Excel file uploaded successfully! The fields have been populated.",
        timer: 2000,
        showConfirmButton: false,
      });
    } catch (error) {
      console.error("Failed to upload Excel file:", error?.response?.data || error.message);
      Swal.fire({
        icon: "error",
        title: "Upload Failed",
        text: error?.response?.data?.message || "Unable to upload the Excel file. Please try again.",
      });
    } finally {
      setUploadSubmitting(false);
    }
  };

  const handleSubmitDeduction = async (e) => {
    e.preventDefault();

    // Validate required fields
    if (!uploadForm.month || !uploadForm.deductionType) {
      Swal.fire({
        icon: "warning",
        title: "Missing Information",
        text: "Please ensure all fields are filled before submitting.",
      });
      return;
    }

    // Prepare the payload
    const formattedDate =
      uploadForm.month && uploadForm.month.length === 7
        ? `${uploadForm.month}-01`
        : uploadForm.month;

    const uploadedEmployeeIds = uploadedRows.map((row) => row.employee?.value);
    const uploadedAmounts = uploadedRows.map((row) => row.amount);
    const manualEmployeeIds = employeeRows.map((row) => row.employee?.value);
    const manualAmounts = employeeRows.map((row) => row.amount);

    let employeeIds = [];
    let amounts = [];

    if (uploadedFromExcel && uploadedRows.length > 0) {
      employeeIds = uploadedEmployeeIds.filter(Boolean);
      amounts = uploadedAmounts;
    } else {
      employeeIds = manualEmployeeIds.filter(Boolean);
      amounts = manualAmounts;
    }

    const payload = {
      date: formattedDate, // Send as a single value
      deduction_type: uploadForm.deductionType.value, // Send as a single value
      employee_id: employeeIds, // Send as an array
      amount: amounts, // Send as an array
    };

    const token = localStorage.getItem("authToken");

    try {
      setUploadSubmitting(true);

      // Determine the endpoint based on the presence of UUID
      const endpoint = uploadForm.uuid
        ? '/v1/salary_deduction/save_employee_deduction'
        : '/v1/salary_deduction/create_employee_deduction';

      // Include UUID in the payload only if it exists
      if (uploadForm.uuid) {
        payload.uuid = uploadForm.uuid;
      }

      // Send the data to the appropriate endpoint
      const response = await api.post(endpoint, withCompanyId(payload));

      console.log("Backend response:", response.data); // Debug log for backend response

      Swal.fire({
        icon: "success",
        title: "Deductions Submitted",
        text: response?.data?.message || "Monthly deductions submitted successfully!",
        timer: 2000,
        showConfirmButton: false,
      });

      // Optionally process the data array if needed
      console.log("Created deductions:", response?.data?.data);

      handleCloseUploadModal();
      fetchDeductionTypes(); // Refresh the deduction list
    } catch (error) {
      console.error("Failed to submit deductions:", error?.response?.data || error.message);
      Swal.fire({
        icon: "error",
        title: "Submission Failed",
        text: error?.response?.data?.message || JSON.stringify(error?.response?.data) || "Unable to submit deductions at this time. Please try again later.",
      });
    } finally {
      setUploadSubmitting(false);
    }
  };

  // Define handleUploadSubmit if it is referenced in the form
  const handleUploadSubmit = async (e) => {
    e.preventDefault();
    // Add logic here if needed, or remove the reference to this function if unused
    console.warn("handleUploadSubmit is not implemented. Please add logic or remove its reference.");
  };

  // Define handleRemoveExcelFile if it is referenced in the file upload logic
  const handleRemoveExcelFile = () => {
    setExcelFile(null);
    setUploadedFromExcel(false);
    setUploadedRows([]);
    setEmployeeRows([{ employee: null, amount: "" }]);
    if (excelFileInputRef.current) {
      excelFileInputRef.current.value = "";
    }
  };

  const modalStyles = {
    overlay: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      backgroundColor: "rgba(0, 0, 0, 0.5)",
      position: "fixed", // Ensure the overlay covers the entire viewport
      top: 0,
      left: 0,
      width: "100vw",
      height: "80vh",
      overflow: "hidden", // Prevent background scrolling
    },
    content: {
      maxHeight: "90vh", // Ensure the modal height does not exceed 90% of the viewport height
      overflowY: "auto", // Enable vertical scrolling for content
      width: "90%", // Adjust width for responsiveness
      maxWidth: "600px", // Optional: Set a maximum width for the modal
      margin: "0 auto", // Center the modal horizontally
      borderRadius: "8px", // Optional: Add rounded corners
      padding: "20px", // Add padding for content spacing
      backgroundColor: "#fff", // Ensure content is visible
    },
  };

  return (
    <div>
      <HeaderNav activePage={pageMap[location.pathname]} />
      <div className={classes.PgeContainerDisp}>
        <div className={classes.actionsbtn_On}>
          <button
            className={classes.btns_New}
            onClick={() => navigate("/transactions/sales-invoice/sale")}
          >
            Sales Invoice
          </button>
          <button
            className={classes.btns_New}
            onClick={() => navigate("/inventory/purchaseOrder")}
          >
            Purchase Invoice
          </button>
          <button
            className={`${classes.btns_New} ${classes.greens}`}
            onClick={() => navigate("/settings/product-services")}
          >
            Product & Services
          </button>
          <button className={`${classes.btns_News} ${classes.greens}`}>
            Add Deductions
          </button>
        </div>

        <header className={classes.FrtHeaderOne}>
          <h2 className={classes.FrtTitleOne}>Monthly Deductions</h2>
        </header>

        <div className={classes.headerActions}>
          <div className={classes.actionsRight}>
            <div className={classes.inputWrapper}>
              <img src={searchicon} alt="Search" className={classes.inputIconGreen} />
              <input type="text" className={classes.searchBar} placeholder="Search all entries" />
            </div>
            <div className={classes.selectWrapper}>
              <select className={classes.dropdown}>
                <option value="">All Methods</option>
                <option value="Paid">Paid</option>
                <option value="Pending">Pending</option>
                <option value="Overdue">Overdue</option>
                <option value="Draft">Draft</option>
              </select>
              <span className={classes.dropdownArrow}>▼</span>
            </div>
            <div className={classes.inputWrapper}>
              <input type="text" className={classes.searchBars} placeholder="Filter..." />
              <img src={filter} alt="Filter" className={classes.inputIcon} />
            </div>
          </div>
          <div className={classes.thrdkad}>
            <div className={classes.kad}>
              <p className={classes.kdptg}>Total Deductions</p>
              <p className={classes.kdptg1}>{NewUser.length}</p>
            </div>

          </div>
          <button
            className={classes.btnssBtnss}
            onClick={handleOpenUploadModal}
          >
            Upload Deduction
          </button>

          {/* <button
            className={classes.btnssBtnss}
            onClick={() => setIsModalOpen(true)}
          >
            New Deduction
          </button> */}

        </div>
        <div className={classes.headerforActions}>
          <div className={classes.actionsSideRight}>
          </div>

        </div>

        <div className={classes.newUserCont}>
          <table className={classes.newUserTable}>
            <thead>
              <tr>
                <th>ID</th>
                <th>Employee ID</th>
                {/* <th>Employee Name</th> */}
                <th>Deductions</th>
                <th>Month</th>
                <th style={{ textAlign: 'right' }}>Amount</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {loading ? (
                Array(5).fill().map((_, idx) => (
                  <tr key={idx}>
                    {Array(5).fill().map((_, i) => (
                      <td key={i}><Skeleton height={20} /></td>
                    ))}
                  </tr>
                ))
              ) : NewUser.length === 0 ? (
                <tr>
                  <td colSpan={7} style={{ textAlign: "center !important" }}>No deductions found.</td>
                </tr>
              ) : (
                NewUser.map((deduction, index) => (
                  <tr key={deduction.id}>
                    {/* <td style={{ width: '50px' }}>{index + 1}</td> */}
                    <td style={{ width: '150px', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', maxWidth: '150px' }} title={deduction.staff_id}>{deduction.staff_id}</td>
                    <td style={{ width: '200px' }}>{deduction.employee?.first_name}</td>
                    <td style={{ width: '200px' }}>{deduction.deduction_type?.description}</td>
                    <td style={{ width: '120px' }}>{deduction.date}</td>
                    <td style={{ width: '120px', textAlign: 'right' }}>{parseFloat(deduction.amount || 0).toLocaleString('en-NG', { style: 'currency', currency: 'NGN' })}</td>
                    <td className={classes.actionsCell}>
                      <div className={classes.actionIcons}>
                        <Edit size={16} className={classes.editActionIcon} onClick={() => openEditModal(deduction)} />
                        <Trash size={16} className={classes.deleteActionIcon} onClick={() => openDeleteModal(deduction)} />
                      </div>
                    </td>
                  </tr>
                ))
              )}
            </tbody>

          </table>

          <div className={classes.paginationContainertxt}>
            <div className={classes.paginationControlstxt}>
              <button>First</button>
              <button className={classes.activation}>1</button>
              <button>Last</button>
              <span className={classes.pageDisplayText}>
                Displaying 1 - {NewUser.length} of {NewUser.length}
              </span>
            </div>
          </div>
        </div>
      </div>

      {/* Add Currency Modal */}
      {isModalOpen && (
        <div className={classes.modalModalOverlay}>
          <div className={classes.modalModalContent}>
            <div className={classes.modalModalHeader}>
              <h2>New Deduction</h2>
              <button
                className={classes.closeModalBtn}
                onClick={() => setIsModalOpen(false)}
              >
                &times;
              </button>
            </div>

            <form onSubmit={handleSubmit}>
              <div className={classes.modalModalBody}>


                <div className={classes.modalFormRow}>
                  <div className={classes.modalFormGroup}>
                    <label>Description</label>
                    <input
                      type="text"
                      name="description"
                      placeholder="Enter deduction description"
                      value={formData.description}
                      onChange={handleChange}
                      required
                    />
                  </div>
                </div>

                <div className={classes.modalFormRow}>
                  <div className={classes.modalFormGroup}>
                    <label>Payable Account</label>
                    <select
                      name="payable_account"
                      value={formData.payable_account}
                      onChange={handleChange}
                      required
                      disabled={isPayableAccountsLoading}
                    >
                      <option value="">
                        {isPayableAccountsLoading
                          ? "Loading payable accounts..."
                          : "Select payable account"}
                      </option>
                      {payableAccounts.map((account) => (
                        <option key={account.id} value={account.id}>
                          {account.gl_name}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className={classes.modalFormGroup}>
                    <label>Expense GL Account</label>
                    <select
                      name="expense_account"
                      value={formData.expense_account}
                      onChange={handleChange}
                      required
                      disabled={isExpenseAccountsLoading}
                    >
                      <option value="">
                        {isExpenseAccountsLoading
                          ? "Loading expense accounts..."
                          : "Select expense account"}
                      </option>
                      {expenseAccounts.map((account) => (
                        <option key={account.id} value={account.id}>
                          {account.gl_name}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
                <div className={classes.modalFormFooter}>
                  <button
                    className={classes.processModalBtn0}
                    disabled={submitting}
                    type="submit"
                  >
                    {submitting ? "Adding..." : "Add Deduction"}
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* Edit Exchange Rate Modal */}
      {isNewModalOpen && (
        <div className={classes.modalModalOverlay}>
          <div className={classes.modalModalContent}>
            <div className={classes.modalModalHeader}>
              <h2>Edit Exchange Rate</h2>
              <button
                className={classes.closeModalBtn}
                onClick={() => {
                  setIsNewModalOpen(false);
                  setSelectedLocation(null);
                }}
              >
                &times;
              </button>
            </div>

            <form onSubmit={handleEditSubmit}>
              <div className={classes.modalModalBody}>
                <div className={classes.modalFormRow}>
                  <div className={classes.modalFormGroup}>
                    <label>Date</label>
                    <input
                      type="date"
                      name="date"
                      value={editFormData.date}
                      onChange={handleEditChange}
                      required
                    />
                  </div>
                  <div className={classes.modalFormGroup}>
                    <label>Currency</label>
                    <Select
                      options={currencyOptions}
                      isLoading={currencies.length === 0}
                      placeholder="Select currency"
                      value={
                        currencyOptions.find(
                          (opt) => opt.value === editFormData.currency
                        ) || null
                      }
                      onChange={(option) =>
                        handleEditChange("currency", option.value)
                      }
                    />
                  </div>
                </div>

                <div className={classes.modalFormRow}>
                  <div className={classes.modalFormGroup}>
                    <label>Exchange Rate</label>
                    <input
                      type="number"
                      step="0.01"
                      name="exchange_rate"
                      placeholder="Enter Exchange Rate"
                      value={editFormData.exchange_rate}
                      onChange={handleEditChange}
                      required
                    />
                  </div>
                </div>
                <div className={classes.modalFormFooter}>
                  <button
                    className={classes.processModalBtn0}
                    disabled={submitting}
                    type="submit"
                  >
                    {submitting ? "Updating..." : "Update Exchange Rate"}
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* Delete Exchange Rate Modal */}
      {isDeleteModalOpen && (
        <div className={classes.modalModalOverlay}>
          <div className={classes.modalModalDeleteContent}>
            <div className={classes.modalModalHeader}>
              <h2 style={{ marginBottom: "auto" }}>Delete Exchange Rate</h2>
              <button
                className={classes.closeModalBtn}
                onClick={() => {
                  setIsDeleteModalOpen(false);
                  setSelectedLocation(null);
                }}
              >
                &times;
              </button>
            </div>

            <div className={classes.modalModalBodyText00}>
              <p>
                Are you sure you want to delete this exchange rate?
                <br />This action cannot be undone.
              </p>
              <div className={classes.modalFormDelFooter}>
                <button
                  className={classes.ModalDeleteBtn0}
                  onClick={handleDelete}
                  disabled={deleting}
                >
                  {deleting ? "Deleting..." : "Delete Exchange Rate"}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Upload Deduction Modal */}
      {isUploadModalOpen && (
        <div className={classes.modalModalOverlay}>
          <div className={classes.uploadModalContent}>
            <div className={classes.modalModalHeader}>
              <h2>Upload Monthly Deduction</h2>
              <button className={classes.closeModalBtn} onClick={handleCloseUploadModal}>
                &times;
              </button>
            </div>

            <form onSubmit={handleUploadSubmit}>
              <div className={`${classes.modalModalBody} ${classes.modalStyles}`}>
                <div className={classes.uploadFormRow}>
                  <div className={classes.uploadFormGroup}>
                    <label>Month</label>
                    <input
                      type="month"
                      value={uploadForm.month}
                      onChange={(e) =>
                        setUploadForm((prev) => ({ ...prev, month: e.target.value }))
                      }
                      required
                    />
                  </div>
                  <div className={classes.uploadFormGroup}>
                    <label>Deduction</label>
                    <Select
                      options={deductionTypeOptions}
                      value={uploadForm.deductionType}
                      onChange={(option) =>
                        setUploadForm((prev) => ({ ...prev, deductionType: option }))
                      }
                      isLoading={loading}
                      placeholder="Select deduction type"
                      className={classes.selectControl}
                    />
                  </div>
                  <div className={classes.uploadButtonGroup}>
                    <label className={classes.hiddenLabel}>Download Template</label>
                    <button
                      type="button"
                      className={classes.downloadTemplateBtn}
                      onClick={handleDownloadTemplate}
                      disabled={templateDownloading}
                    >
                      {templateDownloading ? "Downloading..." : "Download Template"}
                    </button>
                  </div>
                </div>

                <div className={classes.uploadRepeatHeader}>
                  <p>Deduction Entries</p>
                  <div className={classes.uploadRepeatActions}>
                    <button
                      type="button"
                      className={classes.uploadExcelBtn}
                      onClick={() => excelFileInputRef.current?.click()}
                      disabled={uploadSubmitting}
                    >
                      <Upload size={16} />
                      Upload Excel
                    </button>
                    <input
                      type="file"
                      accept=".xls,.xlsx"
                      ref={excelFileInputRef}
                      onChange={handleUploadExcel}
                      className={classes.hiddenFileInput}
                    />
                  </div>
                </div>

                {excelFile && (
                  <div className={classes.fileInfoRow}>
                    <span className={classes.fileName}>{excelFile.name}</span>
                    <button
                      type="button"
                      className={classes.clearFileBtn}
                      onClick={handleRemoveExcelFile}
                      disabled={uploadSubmitting}
                    >
                      Remove
                    </button>
                  </div>
                )}

                {/* {!excelFile && (
                  <div className={classes.manualAddRow}>
                    <button
                      type="button"
                      className={classes.addRowBtn}
                      onClick={handleAddEmployeeRow}
                      disabled={uploadSubmitting}
                    >
                      <Plus size={16} />
                      Add Manual Entry
                    </button>
                  </div>
                )} */}

                {uploadedFromExcel && uploadedRows.length > 0 && (
                  <div style={{ width: '100%', overflowX: 'auto', marginTop: 8 }}>
                    <table className={classes.newUserTable} style={{ marginTop: 0 }}>
                      <thead>
                        <tr>
                          <th style={{ textAlign: 'left' }}>Employee (Uploaded)</th>
                          <th style={{ textAlign: 'right' }}>Amount</th>
                        </tr>
                      </thead>
                      <tbody>
                        {uploadedRows.map((row, idx) => (
                          <tr key={`uploaded-row-${idx}`}>
                            <td style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{row.employee?.label ?? ''}</td>
                            <td style={{ textAlign: 'right' }}>{parseFloat(row.amount || 0).toLocaleString('en-NG', { style: 'currency', currency: 'NGN' })}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                )}

                {!uploadedFromExcel && employeeRows.map((row, index) => (
                  <div className={classes.uploadFormRow} key={`upload-row-${index}`}>
                    <div className={classes.uploadFormGroup}>
                      <label>Employee</label>
                      <Select
                        options={employeeSelectOptions}
                        value={row.employee}
                        onChange={(option) =>
                          handleEmployeeRowChange(index, "employee", option)
                        }
                        isLoading={isEmployeeLoading}
                        placeholder="Select employee"
                        className={classes.selectControl}
                        isClearable
                      />
                    </div>
                    <div className={classes.uploadFormGroup}>
                      <label>Amount</label>
                      <input
                        type="number"
                        min="0"
                        step="0.01"
                        placeholder="Enter amount"
                        value={row.amount}
                        onChange={(e) =>
                          handleEmployeeRowChange(index, "amount", e.target.value)
                        }
                        required
                      />
                    </div>
                    <div className={classes.uploadRowActions}>
                      <label className={classes.hiddenLabel}>Remove</label>
                      <button
                        type="button"
                        className={classes.removeRowBtn}
                        onClick={() => handleRemoveEmployeeRow(index)}
                        disabled={employeeRows.length === 1}
                        title={
                          employeeRows.length === 1
                            ? "At least one entry is required"
                            : "Remove entry"
                        }
                      >
                        <Trash2 size={16} />
                      </button>
                    </div>
                  </div>
                ))}

                {!uploadedFromExcel && (
                  <div className={classes.uploadRepeatHeader}>
                    <button
                      type="button"
                      className={classes.addRowBtn}
                      onClick={handleAddEmployeeRow}
                    >
                      <Plus size={16} />
                      Add Employee
                    </button>
                  </div>
                )}

                <div className={classes.uploadModalFooter}>
                  <button
                    type="button"
                    className={classes.cancelBtn}
                    onClick={handleCloseUploadModal}
                    disabled={uploadSubmitting}
                  >
                    Cancel
                  </button>
                  <button
                    type="submit"
                    className={classes.submitBtn}
                    onClick={handleSubmitDeduction}
                    disabled={uploadSubmitting}
                  >
                    {uploadSubmitting ? "Submitting..." : "Submit Deductions"}
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* Delete Deduction Modal */}
      {isDeleteModalOpen && (
        <div className={classes.modalModalOverlay}>
          <div className={classes.modalModalDeleteContent}>
            <div className={classes.modalModalHeader}>
              <h2 style={{ marginBottom: "auto" }}>Delete Deduction</h2>
              <button
                className={classes.closeModalBtn}
                onClick={() => {
                  setIsDeleteModalOpen(false);
                  setSelectedLocation(null);
                }}
              >
                &times;
              </button>
            </div>

            <div className={classes.modalModalBodyText00}>
              <p>
                Are you sure you want to delete this deduction?
                <br />This action cannot be undone.
              </p>
              <div className={classes.modalFormDelFooter}>
                <button
                  className={classes.ModalDeleteBtn0}
                  onClick={handleDelete}
                  disabled={deleting}
                >
                  {deleting ? "Deleting..." : "Delete Deduction"}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      <Footer />
    </div>
  );
};

export default MonthlyDeduction;